'use strict';

const h = require('phy');

const TraitsTitle = ({ pageType, title }) => {
  if (pageType === 'getaways' || pageType === 'black_label') {
    return h('div', { id: 'variation-title' }, title);
  } else {
    return null;
  }
};

module.exports = TraitsTitle;
